var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "jade-box",
    {
      staticClass: "flex-1",
      attrs: { title: _vm.$t("tpvByAcquirerTitle"), hasPadding: "" },
      scopedSlots: _vm._u([
        {
          key: "action",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "flex items-center gap-1" },
                [
                  _c("jade-switch", {
                    attrs: { name: "acquirersSwitch", disabledFocus: "" },
                    on: { onClick: _vm.toogleType },
                  }),
                  _c("jade-text", [_vm._v("Valor em R$")]),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      [
        _c(
          "dash-card-content-fallback",
          { attrs: { hasData: _vm.hasData } },
          _vm._l(_vm.acquirers, function (item, index) {
            return _c(
              "dash-progress-bar",
              {
                key: item.key + "" + index,
                attrs: {
                  value: item.percentage,
                  color: item.color,
                  currency: item.value,
                  "show-currency": _vm.dataType === _vm.dataTypeEnum.VALUE,
                },
              },
              [
                _c("acquirer-icons", { attrs: { "data-icon": item.leftIcon } }),
                _c("jade-text", [_vm._v(_vm._s(_vm.$t(item.name)))]),
                _c("acquirer-icons", {
                  attrs: {
                    "data-icon": item.rightIcon,
                    dataType: _vm.dataType,
                  },
                }),
              ],
              1
            )
          }),
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }